import { retrieveJsonRequest, sendJsonRequest } from "./utils";

function makePostsUrl(community) {
    if (community) {
        return `/core/v1/communities/${community}/shared/posts`;
    } else {
        return "/core/v1/users/me/saved/posts";
    }
}

function makeFoldersGlobalUrl(community) {
    if (community) {
        return "/core/v1/folders/communities/shared/posts/labels";
    } else {
        return `/core/v1/folders/users/saved/posts/labels`;
    }
}

function makeFoldersCustomUrl(community) {
    if (community) {
        return `/core/v1/communities/${community}/shared/posts/labels`;
    } else {
        return "/core/v1/users/me/saved/posts/labels";
    }
}

export function getFolders(custom, community) {
    const urlMaker = custom ? makeFoldersCustomUrl : makeFoldersGlobalUrl;
    const url = urlMaker(community);

    return retrieveJsonRequest(url, "GET");
}

export function saveToFolder(community, postId, labels) {
    const url = makePostsUrl(community);
    const payload = {
        labels,
        post: { id: postId, timestamp: parseInt(Date.now() / 1000, 10) },
    };
    return sendJsonRequest(url, "POST", payload);
}

export function removeFromFolder(community, postId, labels) {
    const url = makePostsUrl(community);
    const payload = {
        labels,
        post: { id: postId, timestamp: parseInt(Date.now() / 1000, 10) },
    };
    return sendJsonRequest(url, "DELETE", payload);
}
